export default {
  methods: {
    bannerText(content) {
      const text = this.getTranslatedContent('banner', content)
      const $body = new DOMParser().parseFromString(text, 'text/html').querySelector('body')
      // TODO: fix floara
      if ($body.lastChild && $body.lastChild.innerText === 'Powered by Froala Editor') {
        $body.removeChild($body.lastChild);
      }

      this.marginSanitize($body)
      return text ? $body.innerHTML : ''
    },

    bannerPageText(content) {
      const text = this.getTranslatedContent('description_banner_title', content)
      const $body = new DOMParser().parseFromString(text, 'text/html').querySelector('body')

      this.marginSanitize($body)
      return text ? $body.innerHTML : ''
    },

    itemContent(key, content) {
      return this.getTranslatedContent(key, content)
    },

    description(content) {
      const text = this.getTranslatedContent('text', content)
      const $body = new DOMParser().parseFromString(text, 'text/html').querySelector('body')
      // TODO: fix floara
      if ($body.lastChild && $body.lastChild.innerText === 'Powered by Froala Editor') {
        $body.removeChild($body.lastChild);
      }

      this.marginSanitize($body)
      return text ? $body.innerHTML : ''
    },

    textSanitize(content) {
      const $body = new DOMParser().parseFromString(content, 'text/html').querySelector('body')

      this.marginSanitize($body)
      return $body.innerHTML
    },

    marginSanitize($node) {
      for (let i = 0; i < $node.childNodes.length; i++) {
        const $child = $node.childNodes[i]
          if ($child.firstElementChild && $child.firstElementChild.tagName === 'BR') {
          $child.style.height = '15px'
        }
      }
    },

    sanitize($node) {
      for (let i = 0; i < $node.childNodes.length; i++) {
        const $child = $node.childNodes[i]
        this.sanitize($child)
        if ($child.removeAttribute)
          $child.removeAttribute('style')
      }
    }
  },
}
